import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";

/**
 * 確認ダイアログHook。
 * メッセージを指定して確認ダイアログを表示し、結果をtrue、falseで受け取ることができる。
 * 結果はthenで処理する。
 */
export function useConfirmDialog() {

    interface ResolverType {
        resolve: (bool:boolean) => void
        message: string,
    }

    const [param, setParam] = useState<ResolverType>();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    async function WaitConfirm(message:string) {

        setIsOpen(true);

        const result = await new Promise<boolean>((resolve) => {
            setParam({
                resolve: resolve,
                message: message
            });
            
        })

        return(result);
    }

    function ClickOK() {
        setIsOpen(false);
        param?.resolve(true);
    }

    function ClickCancel() {
        setIsOpen(false);
        param?.resolve(false);
    }

    function ConfirmDialog() {
        return(
            <>
                <Dialog
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                >
                    <DialogTitle>確認</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {param?.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="button-ok" onClick={ClickOK}>OK</Button>
                        <Button onClick={ClickCancel}>キャンセル</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }

    return {
        /**
         * 実行すると確認ダイアログが表示される
         */
        waitConfirm: WaitConfirm,

        /**
         * ダイアログを表示する画面要素のどこかに配置する
         */
        ConfirmDialog: ConfirmDialog,
    }
}